import { useCallback } from 'react';
import {
  featureHasUsages,
  getFeatureLimitsData,
  getPerformanceFeatureLimitsFromChannel,
} from 'src/data/featureLimits';
import { useCurrentCustomer } from './useCurrentCustomer';

export const useCustomerCanCreatePerformanceFeatureItem = () => {
  const currentCustomer = useCurrentCustomer();

  return useCallback(
    (channel) => {
      const feature = getPerformanceFeatureLimitsFromChannel(channel);
      const featureLimitsData = getFeatureLimitsData(currentCustomer, feature);

      return featureHasUsages(featureLimitsData);
    },
    [currentCustomer]
  );
};
